<template>
  <div>
    <Loading :visible='isBusy'>
      <BasicTableNoPagination :fields='fields' :table-data='filterData()' @onSelect='onSelect' />
    </Loading>
    <PermissionBasicSidebar ref='sidebar' />
  </div>
</template>

<script>
import { getUserPermission } from '@/util/api'
import Loading from '@/components/Loading'
import { mapGetters } from 'vuex'
import { TabIndex } from '@core/utils/common'
import table from '@core/mixins/table'
import BasicTableNoPagination from '@core/components/common/BasicTableNoPagination'
import { messageChannelOn } from '@core/utils/message'
import { notify } from '@core/utils/elementUtil'
import PermissionBasicSidebar from '@/components/content/permission/PermissionBasicSidebar'

export default {
  name: 'Permissions',
  components: { PermissionBasicSidebar, BasicTableNoPagination, Loading },
  mixins: [table],
  data() {
    return {
      fields: ['selected', 'name', 'extension', 'pathName', 'entityType', 'permission'],
      isBusy: false,
      isAllSelected: false,
      eventName: `${TabIndex.permission}:user`
    }
  },
  computed: {
    ...mapGetters('search', ['searchText'])
  },
  mounted() {
    messageChannelOn('onPermission', () => {
      this.onPermission()
    })
    this.getData()
  },
  methods: {
    onPermission() {
      if (this.selected.length === 0) {
        notify('No record selected!')
        return
      }
      this.$refs['sidebar'].open()
      this.$refs['sidebar'].setPermissions(this.selected)
    },
    filterData() {
      return this.tableData.filter(value => {
        return value.name?.includes(this.searchText) ||
          value.extension?.includes(this.searchText) ||
          value.entityType?.includes(this.searchText) ||
          value.pathName?.includes(this.searchText) ||
          value.permission?.includes(this.searchText)
      })
    },
    async getData() {
      try {
        this.isBusy = true
        const { organisationId, userId } = this.$route.params
        this.tableData = await getUserPermission(organisationId, userId)
      } catch (e) {
        if (e) {
          console.error(e)
        }
      } finally {
        this.isBusy = false
      }
    }
  }
}
</script>

<style scoped>

</style>
